const APP = () => import('@/App.vue');

const MAIN_ROUTES = {
  SIGN_IN: () => import('@/components/sign-in/SignIn.vue'),
  SUPPORT_SIGN_IN: () => import('@/components/sign-in/SupportSignIn.vue'),
  SAML2TEST: () => import('@/components/sign-in/Saml2TestAlert.vue'),
  RESET_PASSWORD: () => import('@/components/forgotten-password/ResetForgottenPassword.vue'),
  REQUEST_PASSWORD_RESET: () => import('@/components/forgotten-password/RequestPasswordReset.vue'),
  DASHBOARD: () => import('@/views/Dashboard.vue'),
  CATALOG: () => import('@/views/Catalog.vue'),
  DATA_PRODUCTS: () => import('@/views/DataProducts.vue'),
  MONITORS: () => import('@/views/Monitors.vue'),
  INTEGRATIONS: () => import('@/views/Integrations.vue'),
  SETTINGS: () => import('@/views/Settings.vue'),
  INCIDENTS: () => import('@/views/Incidents.vue'),
  DESIGN_SYSTEM: () => import('@/views/Design-System.vue'),
  DOMAINS: () => import('@/views/Domains.vue'),
  GRAPH_TEST: () => import('@/components/graph-test/Graph-Test.vue'),
};

const SUB_ROUTES = {
  DASHBOARDS: () => import('@/modules/dashboard/Dashboards.vue'),

  CATALOG_SEARCH: () => import('@/components/catalog/Catalog.vue'),

  ASSET: () => import('@/components/asset/Asset.vue'),
  ASSET_OVERVIEW: () => import('@/components/asset/tabs/Asset-Tab-Overview.vue'),
  ASSET_DBT: () => import('@/components/asset/tabs/Asset-Tab-Dbt.vue'),
  ASSET_DBT_RUNS: () => import('@/modules/catalog/asset/tabs/AssetDbtRuns.vue'),
  ASSET_SCHEMA: () => import('@/components/asset/tabs/Asset-Tab-Schema.vue'),
  ASSET_MONITORS: () => import('@/modules/catalog/asset/tabs/AssetMonitors.vue'),
  ASSET_INCIDENTS: () => import('@/modules/catalog/asset/tabs/AssetIncidents.vue'),
  ASSET_LINEAGE: () => import('@/components/asset/tabs/Asset-Tab-Lineage.vue'),
  ASSET_DOCUMENTATION: () => import('@/components/asset/tabs/Asset-Tab-Documentation.vue'),

  MONITORS_SEARCH: () => import('@/components/monitors/Monitors.vue'),

  RULE_ADD: () => import('@/modules/monitors/monitor-wizard/MonitorWizard.vue'),
  RULE_EDIT: () => import('@/modules/monitors/monitor-wizard/MonitorWizard.vue'),

  // Component is not used anymore but kept for reference
  // as it might be useful in the future.
  DATASOURCE_RUNS: () => import('@/modules/integrations/source/SourceRuns.vue'),

  MONITORING_TABLE_METADATA: () => import('@/modules/monitors/metadata/TableMetadataMonitoring.vue'),

};

const INCIDENT_ROUTE_NAMES = {
  overview: 'incidents.incident.incident_overview',
  lineage: 'incidents.incident.incident_lineage',
  monitors: 'incidents.incident.incident_monitors',
  impactedDashboards: 'incidents.incident.incident_impacted_dashboards',
  notifications: 'incidents.incident.incident_notifications',
} as const;

export {
  APP,
  MAIN_ROUTES,
  SUB_ROUTES,
  INCIDENT_ROUTE_NAMES,
};
